import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getTenantBookingStats = (token, id) => {
    return fetch(`${apiUrl}tenant_booking_stats/${id}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default getTenantBookingStats
